export const GENERATED_IDS = {
    "__TALENT_ID": {
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {}
        },
        "WARRIOR": {
            "PROT": {},
            "FURY": {},
            "ARMS": {}
        },
        "ROGUE": {
            "ASS": {},
            "SUB": {},
            "OUT": {}
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {},
            "HAVOC": {}
        },
        "DRUID": {
            "GUARDIAN": {},
            "FERAL": {},
            "BALANCE": {},
            "RESTO": {
                "INNER_PEACE": "fdb8022d-f199-48db-85e5-59e940100267",
                "TREE": "4b403fe4-2c35-4b0f-832c-770b5ce089cc"
            }
        },
        "PRIEST": {
            "DISC": {
                "EVANGELISM": "370ce0bf-e4f8-47e6-8d7b-028f6832a08f",
                "SHELL": "398e92b9-aca2-414b-854b-6b46f936d1b4",
                "MINDBENDER": "1cc74fb3-d554-44f2-b44e-18906ffa7d7b"
            },
            "HOLY": {
                "SALV": "3590dcf1-d3e1-4b26-b168-b52dd4cf01cc"
            },
            "SHADOW": {}
        },
        "DK": {
            "FROST": {},
            "UNHOLY": {},
            "BLOOD": {}
        },
        "PALADIN": {
            "RET": {},
            "PROT": {},
            "HOLY": {
                "HOLY_AVENGER": "134af8c8-e90a-4105-a656-98d4fd5918d2",
                "CRUSADER": "dbb97a38-ec59-4ca4-ab34-948a9fff0cd3"
            }
        },
        "SHAMAN": {
            "ENH": {},
            "RESTO": {
                "ASC": "45cf1a7d-ec60-4e32-84c6-0388ce7b414e",
                "APT": "f31ca468-6bc7-4e0d-a9fe-2d6dbf542c70",
                "WRT": "d3b5d51c-cc70-4aba-80c0-b910b58afd3f"
            },
            "ELE": {
                "ANCE_GUIDE": "30478e69-f51e-46aa-9423-e9ff1a8babf7"
            }
        },
        "MONK": {
            "WW": {},
            "MW": {
                "CHI_JI": "cd5bb2e8-c5c3-4d17-a3ee-c22a91f8ba6e"
            },
            "BRM": {}
        },
        "HUNTER": {
            "MM": {},
            "SV": {},
            "BM": {}
        }
    },
    "__MODIFIER_ID": {
        "BOON": "6a4705a0-dd2a-4010-a1cc-2514cc30ed94",
        "CONVOKE": "04eb6506-514b-48be-9789-2dd25e68eb16",
        "ASHEN_HALLOW": "bbbc72a1-29d5-4e1f-9cf6-997aae307dcf",
        "CELEST_SPIRIT": "d55d03da-62a4-4a69-af5a-23c98b30d7e8"
    },
    "__SPELL_ID": {
        "MAGE": {
            "FROST": {},
            "FIRE": {},
            "ARCANE": {}
        },
        "WARRIOR": {
            "PROT": {
                "RALLY": "08b4ddb7-406f-44d4-a1c4-aae2be6a498f"
            },
            "FURY": {
                "RALLY": "847870d5-a2c0-4b77-858c-15eb23ccf968"
            },
            "ARMS": {
                "RALLY": "6a6d338d-4b84-4a50-a9e3-8f37662daeee"
            }
        },
        "ROGUE": {
            "ASS": {},
            "SUB": {},
            "OUT": {}
        },
        "WARLOCK": {
            "AFFLI": {},
            "DEMO": {},
            "DEST": {}
        },
        "DH": {
            "VENG": {},
            "HAVOC": {
                "DARK": "f698c4ec-cfe8-42d2-ac6a-63ab648d8b9f"
            }
        },
        "DRUID": {
            "GUARDIAN": {
                "CONVOKE": "424ab64d-26c8-498e-be27-104ecf25ad58",
                "ROAR": "871b2db6-0bfb-412c-bee1-8949cd39c5ba"
            },
            "FERAL": {
                "CONVOKE": "9efa4b56-0063-4717-840b-521fbb96e381",
                "ROAR": "122a4fb0-ec72-4c4b-8e5c-739eeee22f5f"
            },
            "BALANCE": {
                "CONVOKE": "8075ca44-e5c7-40c1-8ee3-1b253afc2f25",
                "ROAR": "775e7f51-767a-4d30-bb28-47264a8377fc"
            },
            "RESTO": {
                "TRANQ": "2a2ca446-af05-4175-a096-20386178f628",
                "CONVOKE": "e2034506-8be7-4043-847f-2df37fd09bd4",
                "ROAR": "a3840044-152d-4ad8-a4ce-703ebafd96d5",
                "TREE": "29b82d85-f01d-44b3-9a3d-a412e434ad7c"
            }
        },
        "PRIEST": {
            "DISC": {
                "EVANGELISM": "f5ba2aba-f309-4572-b903-2e911824454a",
                "SHELL": "ab0233af-e49f-48de-9282-b749b65ef7b0",
                "BOON": "71c61eb5-e18d-493d-9830-28b9a649f138",
                "FIEND": "d6337bdb-993c-4455-8bcd-ff3625f2a5bf",
                "MINDBENDER": "4a31f650-cad0-4b49-85ca-ffcc85a2d3b0",
                "BARRIER": "96c97815-252d-401a-b8d2-24c44d7f36f4",
                "RAPTURE": "c729f088-f820-4fd6-a8a8-2eacef78de0c"
            },
            "HOLY": {
                "HYMN": "75c64452-5926-42bd-9327-c0a5eb71fb3f",
                "BOON": "366fe5ef-19a8-49c8-bb26-875728f600f9",
                "SYMBOL_OF_HOPE": "65638ab9-b5c6-475f-8fe7-85d28d459575",
                "SALV": "b3713050-b55f-4798-a16a-fddb69fe3120"
            },
            "SHADOW": {
                "EMBRACE": "0376f7e6-dc7d-4892-af36-853f217c9c9a"
            }
        },
        "DK": {
            "FROST": {
                "AMZ": "4d584836-442a-4c8a-8d6c-b47ec97f3d4a"
            },
            "UNHOLY": {
                "AMZ": "6d1ac14a-3bd7-4ac7-97c5-3f023434634a"
            },
            "BLOOD": {
                "AMZ": "7a6b407c-b2d8-4f65-a5e0-9247f5031710"
            }
        },
        "PALADIN": {
            "RET": {
                "ASHEN_HALLOW": "657f81b5-3bd5-4c86-af1e-3e1d37fe7943"
            },
            "PROT": {
                "ASHEN_HALLOW": "761c62aa-2b35-42b1-b79e-5cdba63ff4b7"
            },
            "HOLY": {
                "HOLY_AVENGER": "ce709f87-548e-4455-b6dc-70da08f0eca9",
                "CRUSADER": "387a631e-5e9e-49d0-bfa7-9aad48304498",
                "WINGS": "60c0f350-f6a0-41db-ad3c-80323cd1eea6",
                "ASHEN_HALLOW": "2e557d61-9c22-4a95-a688-5fd72efa2051",
                "AM": "82251df1-96b5-457c-870b-7176512ee6ff"
            }
        },
        "SHAMAN": {
            "ENH": {
                "WRT": "c1ea1199-15d2-46ce-9b15-c070b86f2bef"
            },
            "RESTO": {
                "ASC": "94a6281b-669a-4ec8-b536-9671a4cf8bb2",
                "APT": "2d8388ea-9352-40f6-83a2-37fb350af203",
                "WRT": "709c5a8c-8039-41a8-9e92-c62e56f530bb",
                "HTT": "e93d60aa-960d-4f9b-a346-3a9c72e98696",
                "SLT": "fa4b7232-7959-40b2-9393-b09fa336be43"
            },
            "ELE": {
                "ANCE_GUIDE": "f15401db-7e78-4467-ad57-42ff2e1b8753",
                "WRT": "d66fae11-272d-4c76-9c4a-357a08d6e487"
            }
        },
        "MONK": {
            "WW": {},
            "MW": {
                "REVIVAL": "362fa928-ce30-40cf-8e5c-ff5e188f16cd",
                "YULON": "b4e34324-158e-478a-8100-971916bb763b",
                "CHI_JI": "fea0373e-a46e-417d-9d38-0c812350ef50"
            },
            "BRM": {}
        },
        "HUNTER": {
            "MM": {},
            "SV": {},
            "BM": {}
        }
    }
}
